/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CampaignAddonShowPathParams, CampaignAddonShowResponse } from '../types/CampaignAddonShow'

/**
 * GET /campaigns/:campaign/addons
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignAddonController.php CampaignAddonController::show
 */
export async function campaignAddonShow(
	campaign: CampaignAddonShowPathParams['campaign'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignAddonShowResponse>> {
	return axiosInstance.get(`/campaigns/${campaign}/addons`, config)
}
